import { Component,OnInit, Inject, ViewChild, ElementRef} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DOCUMENT } from "@angular/platform-browser";
import { FileUpload } from "../../shared/app/classes/file-upload";
import { DomSanitizer } from '@angular/platform-browser';
import { IMyDpOptions } from 'mydatepicker';
import { Router } from '@angular/router';
import { Validation } from '../../shared/app/services/validation'
import { PayeeAttachment, PayeeAttachmentDetail, PayeeService, PayeeCardsEcommerce, PayeeServiceMID, SubmissionTag} from '../../shared/sdk/models';
import { PayeeApi, StorageApi ,PayeeSubmissionApi , PayeeServiceApi , PayeeCardsEcommerceApi} from '../../shared/sdk/services';
import { FormPage } from '../../shared/app/classes/form-page'
import { GlobalEventsManager } from '../../events-manager.component';
import { SubmissionDetailService } from "../../shared/app/services/";
import { LoopBackConfig } from "../../shared/sdk/lb.config";

@Component({
  selector: 'cards-uat-live',
  templateUrl: 'cards-uat-live.component.html',
  providers: [
    { provide: 'Window',  useValue: window },
    Validation
  ],
  styleUrls: ['../application.css','cards-uat-live.component.css']
})



export class CardsUatLiveComponent extends FileUpload implements OnInit {
  @ViewChild('mdfDownload') mdfDownload: ElementRef;
  @ViewChild('cardGuideDownload') cardGuideDownload: ElementRef;
  @ViewChild('uatsoDownload') uatsoDownload: ElementRef;

  TAG = "CardsUatLiveComponent";

  new:boolean = false;
  src:any;
  mobileSrc:any;
  file_name: any;
  isMobile: boolean;
  randomFileName: string;
  detail: PayeeAttachmentDetail;

  doneUat:boolean;
  submissionTags : Array<SubmissionTag>;
  valid: boolean = true;

  submissionId: number;

  uatSignOff = null;
  uatMerchantDeclarationSignOff = null;

  dateModel: any ;

  todayDate: any;

  minGoLiveDate: any;

  disabledGoLiveDate: boolean = false;
  myDatePickerOptions: IMyDpOptions;

  constructor(
    protected payeeApi: PayeeApi,
    private payeeCardsEcommerceApi: PayeeCardsEcommerceApi,
    private payeeServiceApi: PayeeServiceApi,
    private router: Router, 
    protected storageApi: StorageApi,
    protected eventManager: GlobalEventsManager,
    private validation: Validation,
    private submissionDetailService: SubmissionDetailService,
    private sanitizer:DomSanitizer,
    @Inject(DOCUMENT) private document: Document,
  ) { 
    super(payeeApi, storageApi, eventManager);
    
  }

  attachment: PayeeAttachment; 

  mids: PayeeServiceMID;
  cardsEcom: PayeeCardsEcommerce;

  uatCompleted: boolean = false;

  adminChecklist;
  adminChecklistRemark;

  checklistStatuses = ["Web Checklist Completed","Merchant to review","Pending Website Checklist Approval"];

  liveDateObject:any;

  // Initialisation
  async ngOnInit() { 
    
    this.scrollToTop();
    let date = new Date();
    let minGoLiveDateObject = this.addDays(new Date(),5);
    this.todayDate  = { 
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
      };
    this.minGoLiveDate ={
      year: minGoLiveDateObject.getFullYear(),
      month: minGoLiveDateObject.getMonth() + 1,
      day: minGoLiveDateObject.getDate()
    }
    

    this.myDatePickerOptions ={
      // other options...
      dateFormat: 'dd.mm.yyyy',
      editableDateField: false,
      openSelectorOnInputClick: true,
      disableUntil: this.todayDate
    };

    this.randomFileName = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)+".pdf";
    if (window.screen.width < 1200) { // 768px portrait
      this.isMobile = true;
    }
    this.getFileDetails('uat_cards_ecom_signoff').subscribe(
      res => {
        if (res) {
          console.log(this.TAG + " getFileDetails('uat_cards_ecom_signoff')");
          console.log(res);
          if (res.length > 0) {
            this.uatSignOff = res[0].file_name;
          }
          
        } 
      }
    );

    this.getFileDetails('uat_cards_merchant_declaration_signoff').subscribe(
      res => {
        if (res) {
          console.log(this.TAG + " getFileDetails('uat_cards_merchant_declaration_signoff')");
          console.log(res);
          if (res.length > 0) {
            this.uatMerchantDeclarationSignOff = res[0].file_name;
          }
          
        } 
      }
    );
    
    this.getEcomTechData().subscribe(
      (res:Array<PayeeService>) => {

        console.log(this.TAG + "getEcomTechData: ");
        console.log(res);

        this.eventsManager.loaded(true);

        this.mids = res[0].MIDs;
        this.mids.amex_12m_prod_hashkey
        this.cardsEcom = res[0].cardEcom;
        this.submissionTags = res[0].submission.submission_tags;

        this.submissionId = res[0].submission.id;

        if (this.cardsEcom.go_live_date != null) {
          
          this.liveDateObject = new Date(this.cardsEcom.go_live_date);
          this.minGoLiveDate.year = this.liveDateObject.getFullYear();
          this.minGoLiveDate.month = this.liveDateObject.getMonth() + 1;
          this.minGoLiveDate.day = this.liveDateObject.getDate();

          this.dateModel = {
            date:this.minGoLiveDate
          };
          this.disabledGoLiveDate = true;
        }

        if (this.submissionTags) {
          //If uat completed status is in
          if(this.submissionTags.filter(
            (submission_tags => submission_tags.tag_id == 22)
          ).length > 0){
            this.uatCompleted = true;
          }
        }
        
      },
      err => {
        this.eventsManager.loaded(true);
        console.log(err)
        this.router.navigate(['/dashboard']);
      }
    );

  }


  getEcomTechData(){
    let filter = {
      where: {
        'submission_id': this.submissionDetailService.getCurrentSubmissionId()
      },
      include:[
        "MIDs",
        "cardEcom",
        {
          "relation":"submission",
          "scope":{
            "include":"submission_tags"
          }
        }
      ],
      limit: 1
    };

    return this.payeeApi.getServices(this.payeeApi.getCurrentId(),filter);
  }

  

  addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  updateGoLiveDate(){
    return this.payeeCardsEcommerceApi.updateGoLiveDate(this.cardsEcom.payee_service_id,this.dateModel.jsdate.toString());
  }


  public innerHtml() {
    return this.sanitizer.bypassSecurityTrustHtml( 
        "<object data='" + LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() + "/storages/" + this.payeeApi.getCurrentId() + "/download/" + this.file_name + "?access_token=" + this.payeeApi.getCurrentToken().id + "' type='application/pdf' class='embed-responsive-item'>" +
        "<embed src='" + LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() + "/storages/" + this.payeeApi.getCurrentId() + "/download/" + this.file_name + "?access_token=" + this.payeeApi.getCurrentToken().id  + "' type='application/pdf' />" +
        "</object>");
  }

  addEventListeners() {}

  
  submit(submit?: boolean) {
    // Send to temp storage
    let promises =[];
    let that = this;

    this.valid = this.validate();

    if (this.valid) {
      console.log(this.TAG+":submit");

      this.updateGoLiveDate().subscribe(
        (res) => {
          console.log(res);
          this.eventsManager.showPopUp("UAT sign off sheet and expected Go-Live date have been submitted.");
          this.router.navigate(['/dashboard']);
        },
        err => {
          console.log(err);
          this.eventsManager.showPopUp("Unable to submit. Please try again later");
        }
      );

    }
   
   
  }

  downloadMDF(){
    this.mdfDownload.nativeElement.click();
  }
  downloadCG(){
    this.cardGuideDownload.nativeElement.click();
  }
  downloadUSO(){
    this.uatsoDownload.nativeElement.click();
  }

  modifyDate(date: string) {
    return date.charAt(3) + date.charAt(4) + '-' + date.charAt(0) + date.charAt(1) + date.substring(5);
  }

  addDoc(name: string, event, zip, submissionId) {
    super.addDoc(name, event, zip,submissionId);
  }

  deleteDoc(name: string) {
    super.deleteDoc(name);
  }

  
  updateDocStatus(name: string, fileName?: string) {
    switch (name) {
      case 'uat_cards_ecom_signoff':
        this.uatSignOff = fileName;
        break;
      case 'uat_cards_merchant_declaration_signoff':
        this.uatMerchantDeclarationSignOff = fileName;
        break;
        
    }
  };

  validateDocs() {
    this.docsValid = this.uatSignOff;
    this.docsValid = this.uatMerchantDeclarationSignOff;
    return this.docsValid;
  };

  validate() {
    this.valid = true;
    this.docsValid = true;
    this.valid = this.dateModel;
    // this.valid = this.uatSignOff;
    this.valid = this.validateDocs() && this.valid;
    this.valid = this.doneUat && this.valid;
    return this.valid;
  }

  // Scrolling
  scrollToTop() {
    window.scroll(0, 0);
    document.body.getElementsByClassName('scroll_cards_uat_live')[0].scrollTop = 0;
  }

  scrollToSave() {
    document.body.getElementsByClassName('scroll_cards_uat_live')[0].scrollTop = document.getElementById('save_cards_uat_live').offsetTop;
  }


}
